// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falGripLines: CreateIconOptions = {
  "displayName": "FALGripLines",
  "viewBox": "0, 0, 448, 512",
  "d": "M448 192c0-8.8-7.2-16-16-16L16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16zm0 128c0-8.8-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16z"
};
